var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconKeyResult48Line = function SvgIconKeyResult48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m38.072 25.752-4.77-4.78a2.9 2.9 0 0 0-2.29-.84l-7.79.65-7.82-7.81 5.69.14.09-3.4-8.68-.21a2.89 2.89 0 0 0-3 3l.21 8.69 3.4-.09-.14-5.69 7.81 7.82-.65 7.79a2.919 2.919 0 0 0 .84 2.29l4.78 4.77a2.88 2.88 0 0 0 2 .86 2.9 2.9 0 0 0 2.89-2.67l.42-5.12 5.13-.42a2.89 2.89 0 0 0 2.48-1.9 2.86 2.86 0 0 0-.6-3.08Zm-14.5 5.28.39-4.7 3.85 3.85-.39 4.7-3.85-3.85Zm6.64-3.25-3.84-3.85 4.69-.39 3.85 3.85-4.7.39Z",
    fill: "current"
  })));
};
export default SvgIconKeyResult48Line;